import $ from 'jquery';

$(function(){

	// if present, maintain the height of parallax background element
	if($('.hero-bg-image').length == 1) {
		$(window).resize(function(){
			var h = Math.ceil($('section.hero').outerHeight() + $('section.hero').offset().top);
			$('.hero-bg-image').css('height', h+'px');
		});
	}
	
});